import { useMutation } from "react-query";
import { NovoHistoricoCobranca } from "../typings";
import http from "infra/http";

function useSaveHistoricoCobranca(id?: string) {
  return useMutation(
    `/v1/historico-cobranca`,
    (data: NovoHistoricoCobranca) =>
      id
        ? http.put(`/v1/historico-cobranca/${id}`, data)
        : http.post(`/v1/historico-cobranca`, data),
  );
}

export default useSaveHistoricoCobranca;
